__turbopack_context__.v({
  "Background": "onwDfq_Background",
  "ClipContainer": "onwDfq_ClipContainer",
  "Container": "onwDfq_Container",
  "Highlight": "onwDfq_Highlight",
  "Image": "onwDfq_Image",
  "ImageContainer": "onwDfq_ImageContainer",
  "Root": "onwDfq_Root",
  "Text": "onwDfq_Text",
  "TextContainer": "onwDfq_TextContainer",
  "skeleton-loading": "onwDfq_skeleton-loading",
});
